// import logo from "../assets/images/logo.jpeg";
import logout_image from "../assets/images/logout_image.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { AuthContext } from "./AuthContext";
import { useContext } from "react";

function Header() {
  const [dropdown, setDropdown] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const showProfile = () => {
    setDropdown(!dropdown);
  };

  return (
    <div>
      <div className="header">
        <div className="user-info" onClick={showProfile}>
          {/* <img height="40" id="header-img" src={logo} width="40" alt="" /> */}
          <span> Current User : {user.name} </span>
          <div
            className="dropdown"
            style={{ display: dropdown ? "block" : "none" }}
          >
            <ul>
              <li onClick={handleLogout}>
                <img src={logout_image} id="logout" /> Logout
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="header-content">
        <h2> PROJECT PROGRESS REPORT </h2>
        <p> &copy; 2025 Script IT Solution </p>
      </div>
    </div>
  );
}

export default Header;
